var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgStorefront(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 28,
    height: 28,
    viewBox: "0 0 28 28",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_1547_10475)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M5.25 15.2676V23.6249H22.75V15.2676",
    stroke: "black",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M5.90625 4.375H22.0938C22.2838 4.37504 22.4687 4.43697 22.6205 4.55142C22.7722 4.66587 22.8826 4.82663 22.9348 5.00937L24.5 10.5H3.5L5.06844 5.00937C5.12055 4.82717 5.23041 4.66681 5.3815 4.5524C5.53259 4.438 5.71674 4.37575 5.90625 4.375Z",
    stroke: "black",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M10.5 10.5V12.25C10.5 13.1783 10.1313 14.0685 9.47487 14.7249C8.8185 15.3813 7.92826 15.75 7 15.75C6.07174 15.75 5.1815 15.3813 4.52513 14.7249C3.86875 14.0685 3.5 13.1783 3.5 12.25V10.5",
    stroke: "black",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M17.5 10.5V12.25C17.5 13.1783 17.1313 14.0685 16.4749 14.7249C15.8185 15.3813 14.9283 15.75 14 15.75C13.0717 15.75 12.1815 15.3813 11.5251 14.7249C10.8687 14.0685 10.5 13.1783 10.5 12.25V10.5",
    stroke: "black",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M24.5 10.5V12.25C24.5 13.1783 24.1313 14.0685 23.4749 14.7249C22.8185 15.3813 21.9283 15.75 21 15.75C20.0717 15.75 19.1815 15.3813 18.5251 14.7249C17.8687 14.0685 17.5 13.1783 17.5 12.25V10.5",
    stroke: "black",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_1547_10475"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 28,
    height: 28,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgStorefront);
export default __webpack_public_path__ + "static/media/storefront.10ee66d55de6397a0e08ae8df03ec2b2.svg";
export { ForwardRef as ReactComponent };